import React from 'react';
import classNames from "classnames";

import Framework from "@beardeddevops/react.framework"
import {Objects} from "components";

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

const breadcrumbsStatic = [{
	name: 'Videos',
	url: '/videos',
	icon: 'map',
}];

export default class Video extends Framework.Components.View {

	constructor(props) {
		super(props);
	}

	render() {
		let {match, history, baseUrl, reloadShell} = this.props;
		let {name} = this.state;

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name,
				url: `/videos/${match.params.id}`,
				icon: 'map-marker',
			}
		]);

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={history}/>

					<Objects.Video
						id={match.params.id}
						history={history}
					/>

			</div>
		)
	}
};